document.addEventListener('DOMContentLoaded', () => {
  const navSection = document.querySelector('.navigation-scroll-to-content');
  const header = document.querySelector('.oxy-header-wrapper');
  const FIXED_HEADER_HEIGHT = header.offsetHeight;

  if (!navSection) return;

  const navLinks = navSection.querySelectorAll('.ct-link-text');
  const sectionIds = Array.from(navLinks).map(link => link.getAttribute('href'));
  const sections = sectionIds.map(id => document.querySelector(id)).filter(Boolean);

  let ticking = false;

  const removeActiveClasses = () => navLinks.forEach(link => link.classList.remove('active'));
  const setActiveLink = id => {
    removeActiveClasses();
    const activeLink = navSection.querySelector(`a[href="${id}"]`);
    if (activeLink) activeLink.classList.add('active');
  };

  const getCurrentSectionId = scrollCenter => {
    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      const sectionTop = window.scrollY + rect.top;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (scrollCenter >= sectionTop && scrollCenter < sectionBottom) {
        return `#${section.id}`;
      }
    }
    return null;
  };

  const handleScroll = () => {
    if (ticking) return;

    window.requestAnimationFrame(() => {
      const scrollCenter = window.scrollY + window.innerHeight / 2;
      const currentSectionId = getCurrentSectionId(scrollCenter);
      currentSectionId ? setActiveLink(currentSectionId) : removeActiveClasses();
      ticking = false;
    });

    ticking = true;
  };

  const handleNavClick = e => {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute('href');
    const targetSection = document.querySelector(targetId);  
    
    window.scrollTo({
      top: targetSection.offsetTop - FIXED_HEADER_HEIGHT,
      behavior: 'smooth'
    });
  };

  navLinks.forEach(link => link.addEventListener('click', handleNavClick));
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('load', handleScroll);

  handleScroll();
});
